import { useState } from "react";

//ui
import { Grid, Stack, Typography } from "@mui/material";
import MainCard from "ui-component/cards/MainCard";
import Button from "@mui/material/Button";

//project imports
import { gridSpacing } from "store/constant";
import SubscriptionTable from "./subscriptionTable";
import SearchBar from "ui-component/SearchBar";
import { useAppDispatch, useAppSelector } from "store/hooks";

import {
  selectsubscription,
  setSearchText,
  setSubscriptionStatus,
  setSubscriptionPlan,
} from "store/slice/subscriptionSlice";
import { StatusFilterDialog } from "./searchFilterDialog";

// ==============================|| USER LIST STYLE 1 ||============================== //

const Subscription = () => {
  const dispatch = useAppDispatch();
  const [statusFilterOpen, setStatusFilterOpen] = useState<boolean>(false);

  const { searchText, subscriptionStatus, subscriptionPlan } = useAppSelector(
    selectsubscription
  );

  const handleStatusFilterOpen = () => {
    setStatusFilterOpen(true);
  };

  const handleStatusFilterClose = (filter?: "active" | "disabled") => {
    setStatusFilterOpen(false);
    // if (filter) {
    //   dispatch(setFilter(filter || ""));
    //   // perform search/filter action with selected filter here
    // }
  };

  const handleRemoveFilter = () => {
    dispatch(setSubscriptionStatus([]));
    dispatch(setSubscriptionPlan([]));
  };
  return (
    <>
      <Grid container>
        <Grid
          item
          xs={12}
          sx={{
            backgroundColor: "#fff",
            padding: "30px",
            borderTopLeftRadius: "12px",
            borderTopRightRadius: "12px",
          }}
        >
          <Grid container direction="row" spacing={2} alignItems="center">
            <Grid item md={6}>
              <Typography variant="h3" gutterBottom>
                Account Subscriptions
              </Typography>
            </Grid>
            <Grid item md={6}>
              <Stack
                direction="row"
                justifyContent="flex-end"
                alignItems="center"
                spacing={2}
              >
                {(subscriptionPlan.length != 0 ||
                  subscriptionStatus.length != 0) && (
                  <Button
                    size="large"
                    color="primary"
                    variant="outlined"
                    onClick={handleRemoveFilter}
                    className="fixed-width"
                  >
                    Clear filter
                  </Button>
                )}
                <Button
                  size="large"
                  color="primary"
                  variant="outlined"
                  className="fixed-width"
                  onClick={handleStatusFilterOpen}
                >
                  Filter
                </Button>
                <SearchBar
                  searchText={searchText}
                  setSearchText={setSearchText}
                />
              </Stack>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <StatusFilterDialog
            open={statusFilterOpen}
            onClose={handleStatusFilterClose}
          />
          <SubscriptionTable />
        </Grid>
      </Grid>
    </>
  );
};

export default Subscription;
